import { CSS as TableCSS } from '../components/table/table.style';
import { DefaultTheme } from '../components/theme';

export const CSS = {
	container: 'c-OrgSearch',
	title: 'c-OrgSearch__Title',
	message: 'c-OrgSearch__Message',
	search: {
		container: 'c-OrgSearch__Search',
		row: 'c-OrgSearch_row',
		section: 'c-OrgSearch__section',
		sectionRight: 'c-OrgSearch__section--right',
	},
	table: 'c-OrgSearch__Table',
	tableCell: 'c-OrgSearch__TableCell',
	tableCellFaint: 'c-OrgSearch__TableCell--faint',
	tableCellGhost: 'c-OrgSearch__TableCell--ghost',
	tableCellRoleActions: 'c-OrgSearch__TableCellRole',
	box: {
		container: 'c-OrgSearch__Box',
		icon: 'c-OrgSearch__icon',
		input: 'c-OrgSearch__input',
		clear: 'c-OrgSearch__clear',
	},
};

const SPACE_10 = DefaultTheme.space(10);
const SPACE_7 = DefaultTheme.space(7);

export const Style = {
	[CSS.search.container]: {
		height: SPACE_10,
		'min-height': SPACE_10,
		'margin-left': '16px',
		'margin-right': '16px',
		color: 'rgba(255,255,255,0.97)',
		[`& .${CSS.box.container}`]: {
			flex: '1',
			height: SPACE_7,
		},
	},
	[CSS.search.row]: {
		display: 'flex',
		'flex-direction': 'row',
		'align-items': 'center',
		height: SPACE_10,
		'padding-left': DefaultTheme.space(14),
		'padding-right': DefaultTheme.space(2),
		'min-height': SPACE_10,
		'background-color': DefaultTheme.background.darkGrey,
		color: 'rgba(255,255,255,0.97)',
	},
	[CSS.search.section]: {
		display: 'flex',
		flex: 1,
		'align-items': 'center',
	},
	[CSS.search.sectionRight]: {
		'justify-content': 'flex-end',
	},
	[CSS.box.container]: {
		'background-color': DefaultTheme.background.mediumGrey,
		padding: `0 ${DefaultTheme.space(2)}`,
		display: 'flex',
		'align-items': 'center',
		color: DefaultTheme.font.color.white,
	},
	[CSS.box.input]: {
		flex: '1',
		border: 'none',
		outline: 'none',
		'background-color': 'transparent',
		'font-family': DefaultTheme.font.family,
		'font-size': DefaultTheme.font.size,
		color: DefaultTheme.font.color.white,
		'margin-left': DefaultTheme.space(4),
	},
	[`${CSS.box.input}::placeholder`]: {
		opacity: '0.6',
		color: DefaultTheme.font.color.white,
		transition: 'opacity 0.2s ease',
	},
	[CSS.box.clear]: {
		color: DefaultTheme.font.color.white,
	},
	[`${CSS.box.input}:focus::placeholder`]: {
		opacity: '0.8',
		color: DefaultTheme.font.color.white,
	},
	[CSS.box.icon]: {
		'pointer-events': 'none',
	},
	[CSS.container]: {
		[`& .${TableCSS.container}`]: {
			width: '80%',
			'margin-bottom': DefaultTheme.space(6),
		},
		[`& .${TableCSS.cell}:nth-last-of-type(2)`]: {
			overflow: 'visible',
		},
	},
	[CSS.tableCellFaint]: {
		color: DefaultTheme.font.color.supporting,
	},
	[`${TableCSS.row}:hover .${CSS.tableCellGhost}`]: {
		visibility: 'visible',
	},
	[CSS.tableCellGhost]: {
		visibility: 'hidden',
	},
	[CSS.tableCellRoleActions]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'flex-end',
		'& .mdl-button': {
			'font-size': 'inherit',
		},
	},
};
